// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__6Goa2","cell":"ColumnAccessor_cell__2YkN-","firstCellAccent":"ColumnAccessor_firstCellAccent__jbdJP"};